import { useCallback } from "react";

export const useTimeView = ({
  bookDetails = {},
  setBookDetails = () => {},
}) => {
  const updateSlotCount = useCallback(
    (value, selectedSlot, active_booking_date) => {
      const date = bookDetails?.active_booking_date || active_booking_date;
      if (!selectedSlot && !date) return;

      const max = selectedSlot?.remaining_capacity;

      setBookDetails((prev) => {
        const bookings = [...(prev.bookings || [])];

        const bookingIndex = bookings.findIndex((b) => b?.date === date);

        const booking =
          bookingIndex > -1
            ? { ...bookings[bookingIndex] }
            : { date, time_slots: [] };

        const timeSlots = [...(booking?.time_slots || [])];

        const slotIndex = timeSlots.findIndex(
          (t) => t?.time === selectedSlot?.start_time,
        );

        const current = slotIndex > -1 ? timeSlots?.[slotIndex]?.no_of_slot : 0;

        /* ---------------- Resolve next value ---------------- */

        let next =
          Math.abs(value) === 1
            ? current + value // +/- buttons
            : Number(value); // direct input

        // Clamp safely
        next = Math.max(0, Math.min(next, max));

        /* ---------------- Apply change ---------------- */

        if (next === 0) {
          // Remove slot
          if (slotIndex > -1) {
            timeSlots.splice(slotIndex, 1);
          }
        } else {
          const updatedSlot = {
            time: selectedSlot?.start_time,
            no_of_slot: next,
            remaining_capacity: selectedSlot?.remaining_capacity,
          };

          if (slotIndex > -1) {
            // Existing slot → update in place
            timeSlots[slotIndex] = updatedSlot;
          } else {
            // New slot → add to TOP
            timeSlots?.unshift(updatedSlot);
          }
        }

        /* ---------------- Persist booking ---------------- */

        if (timeSlots?.length === 0) {
          // Remove empty booking
          if (bookingIndex > -1) bookings?.splice(bookingIndex, 1);
        } else {
          booking.time_slots = timeSlots;

          if (bookingIndex > -1) {
            bookings[bookingIndex] = booking;
          } else {
            bookings.push(booking);
          }
        }

        return { ...prev, bookings };
      });
    },
    [bookDetails?.active_booking_date, setBookDetails],
  );

  const removeSlot = useCallback(
    (slot, active_booking_date) =>
      updateSlotCount(0, slot, active_booking_date),
    [updateSlotCount],
  );

  return { removeSlot, updateSlotCount };
};
